export class Branch {
    constructor(props) {
        Object.assign(this, props);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Branches/Model.ts
// module id = 337
// module chunks = 0